/**
 * トップ「3つの買取方法」タブ（[data-top-tabs]）
 */
(function () {
  function activateTab(tabs, panels, index) {
    const max = tabs.length - 1;
    const i = Math.max(0, Math.min(index, max));

    tabs.forEach(function (tab, n) {
      var selected = n === i;
      tab.classList.toggle("is-active", selected);
      tab.setAttribute("aria-selected", selected ? "true" : "false");
      tab.tabIndex = selected ? 0 : -1;
    });

    panels.forEach(function (panel, n) {
      var show = n === i;
      panel.hidden = !show;
      panel.classList.toggle("is-active", show);
    });
  }

  function init(root) {
    var tablist = root.querySelector('[role="tablist"]');
    if (!tablist) return;

    var tabs = Array.prototype.slice.call(
      tablist.querySelectorAll('[role="tab"]'),
    );
    var panels = tabs
      .map(function (tab) {
        var id = tab.getAttribute("aria-controls");
        if (!id) return null;
        var panel = document.getElementById(id);
        return panel && root.contains(panel) ? panel : null;
      })
      .filter(Boolean);

    if (!tabs.length || panels.length !== tabs.length) return;

    tabs.forEach(function (tab, index) {
      tab.addEventListener("click", function () {
        activateTab(tabs, panels, index);
        tab.focus();
      });
    });

    tablist.addEventListener("keydown", function (e) {
      var current = tabs.indexOf(document.activeElement);
      if (current === -1) return;

      var next = current;
      if (e.key === "ArrowRight" || e.key === "ArrowDown") {
        next = current + 1 > tabs.length - 1 ? 0 : current + 1;
      } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
        next = current - 1 < 0 ? tabs.length - 1 : current - 1;
      } else if (e.key === "Home") {
        next = 0;
      } else if (e.key === "End") {
        next = tabs.length - 1;
      } else {
        return;
      }

      e.preventDefault();
      activateTab(tabs, panels, next);
      tabs[next].focus();
    });
  }

  document.querySelectorAll("[data-top-tabs]").forEach(init);
})();
